<template>
    <div>
        <div class="w" id="content">
            <div class="s_tl">
                当前位置：<a href="/">首页</a>
                <em class="lr3">&#62;</em>
                <a href="/help">帮助中心</a>
                <em class="lr3">&#62;</em>
                <a href="">新手上路</a>
                <em class="lr3">&#62;</em>
                <a href="">夜樱情趣商城订购流程</a>
            </div>
            <div class="ubg">
                <left-side></left-side>
                <!--left over-->
                <div class="u_r">
                    <div class="ah1 alC yahei">
                        <h1 class="f18">夜樱情趣商城订购流程</h1>
                        <p class="c9">发布时间：2022-01-04</p>
                    </div>
                    <div class="ainfo ov yahei">
                        <p class="font16">
                            <strong>一、进入夜樱情趣商城官方网站挑选需要的商品，并点击“立即购买”或者“加入购物车”；</strong>
                        </p>
                        <p>
                            <img alt="" width="400" height="200" src="../../assets/image/common/tup3.png">
                        </p>
                        <p><br></p>
                        <p class="font16">
                            <strong>二、如不再继续购物，点击“去结算”</strong>
                        </p>
                        <p>
                            <img src="../../assets/image/common/4.png" alt="" width="400" height="200">
                        </p>
                        <p><br></p>
                        <p>
                            <strong class="font16">三、进入订单提交页面，确认商品清单&gt;收货信息&gt;选择支付方式&gt;提交订单</strong>
                        </p>
                        <p>
                            <img src="../../assets/image/common/tup5.png" alt="" width="300" height="400">
                            <img src="../../assets/image/common/tup6.png" alt="" width="300" height="400">
                            <img src="../../assets/image/common/tup7.png" alt="" width="300" height="400">
                        </p>
                        <p class="font14">请务必填写真实信息，以便能顺利收到您订购的商品。</p>
                        <p class="font14">1）不登陆也可以订单购买，方便快捷；登陆购买可享受会员折扣（最低9.8折）并累加积分，建议登陆购买；</p>
                        <p class="font14">&nbsp;2) &nbsp;货到付款需满50元，满198元包邮；在线支付（支付宝/微信等）满99元包邮，建议在线支付；</p>
                        <p><br></p>
                        <p>
                            <strong class="font16">四、如果支付方式选择在线支付，则需完成支付；如支付方式选择货到付款，订购成功后，客服人员与您确认收货地址后发货；</strong>
                        </p>
                        <p>
                            <img src="../../assets/image/common/tup8.png" alt=""  height="300">
                        </p>
                        <p><br></p>
                        <p class="font16">
                            <strong>五、订单确认后我们会尽快发货，为保护隐私，快递单写【礼品】字样；</strong>
                        </p>
                        <p><br></p>
                        <p class="font16">
                            <strong>六、订单查询</strong>
                        </p>
                        <p class="font14">订购完成后，PC端用户可在“我的订单”处查询，移动端用户可在“会员”处查询</p>
                        <p><br></p>
                    </div>
                    <!--info over-->
                    <p class="lh30"></p>
                    <p class="bline" style="padding: 30px 0px 0 0;"></p>
                    <p class="lh30"></p>
                    <p style="font-size:16px;">
                        <a href="/help/dianhuadinggou" style="float:left;">上一篇:电话订购流程说明</a>
                        <a href="/help/weixindinggou" class="pl10" style="float:right">下一篇:微信订购</a>
                    </p>
                </div>
                <!--right over-->
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Left_side from "@/components/help/left-side"
export default {
    components:{
        'left-side': Left_side
    },
}
</script>

<style scoped>
.font16{font-size: 16px;}
.font14{font-size: 14px;}
.ainfo {line-height: 32px;padding-top: 10px;font-size: 14px;}
.ubg{border:1px solid #e5e5e5;background-color:#fff;overflow:hidden;}
.u_l{width:170px;padding:10px;background:#fff;border-right:1px solid #e5e5e5;}
.u_r{padding:10px 40px 30px 40px;border-left:1px solid #e5e5e5;line-height:25px;background:#fff;margin-left:190px;min-height:600px;overflow: hidden;}
.dsl{display:inline;font-weight:normal;}
.udl{margin:0 5px 15px 5px;}
.udl dt{border-bottom:1px solid #e5e5e5;line-height:40px;display:block;font-size:14px;color:#333;font-weight:bold;margin-bottom:10px;}
.udl dd{line-height:30px;text-indent:15px;}
.udl a{display:block;color:#777;margin-bottom:1px;}
.udl a:hover,.udl a.on{color:#c40000;text-decoration:none; background-color:#e5e1e1;}
.article{width:100%;}
.article li{border-bottom:1px dashed #ddd;display:block;width:100%;font-size:14px;line-height:45px;}
.article a{display:block;width:100%;overflow:hidden;}
.article a:hover{color:#c40000;}
.ah1{color:#333;line-height:30px;padding-bottom:10px;border-bottom:2px solid #ddd;}
.a_goods a{width:220px;height:280px;display:inline;float:left;margin:10px 6px;line-height:18px;white-space:nowrap;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/components/help/dinggouliucheng.vue